import QuantityControl from './QuantityControl';
import { formatPrice } from '../utils/formatPrice';

function CartDrawer({ open, items, onClose, onClear, onSetQty }) {
  if (!open) {
    return null;
  }

  return (
    <div className="cartOverlay" role="dialog" aria-label="购物车">
      <button className="cartMask" type="button" aria-label="关闭" onClick={onClose} />
      <div className="cartPanel">
        <div className="cartHeader">
          <div className="cartTitle">购物车</div>
          <button className="textBtn" type="button" onClick={onClear}>
            清空
          </button>
        </div>
        <div className="cartList">
          {items.map(({ product, qty }) => (
            <div key={product.id} className="cartRow">
              <div className="cartRowLeft">
                <div className="cartRowName">{product.name}</div>
                <div className="cartRowPrice">
                  {product.price > 0 ? formatPrice(product.price) : '免费'}
                </div>
              </div>
              <div className="cartRowRight">
                <QuantityControl
                  value={qty}
                  onDecrease={() => onSetQty(product.id, qty - 1)}
                  onIncrease={() => onSetQty(product.id, qty + 1)}
                  decreaseLabel={`减少 ${product.name}`}
                  increaseLabel={`增加 ${product.name}`}
                />
              </div>
            </div>
          ))}
          {items.length === 0 ? <div className="empty">购物车还是空的</div> : null}
        </div>
      </div>
    </div>
  );
}

export default CartDrawer;
